import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  qualificationStatusReturn: {
    width: '320px',
    textAlign: 'center',
    margin: 'auto',
    overflow: 'hidden'
  },
  successButton: {
    backgroundColor: '#347F42',
    width: '100%',
    color: '#FFFFFF',
    margin: '0px',
    '&:hover': {
      backgroundColor: '#035412',
    },
  },
}));
